/**
 * 会话问题服务
 * 从 AZ_AI_MVR_H5/src/services/conQuestion.ts 迁移
 */
import request from "../../utils/request";

/** 创建会话问题 */
export function createConQuestion(data: { content: string; conversationId: string }) {
  return request
    .post("/project/conquestion/create", {
      Entity: {
        Content: data.content,
        ConversationId: data.conversationId,
      },
    })
    .then((r) => r.data);
}
